import axios from 'axios';

let prefix = "/farming-difficulty"

const FarmingLevelDifficultyApi = {
	listFarmingLevelDifficulty(payload) {
		return axios.get(prefix + "/list", { params: payload })
	},
	getFarmingLevelDifficultyInfo(payload) {
		return axios.get(prefix + "/get", { params: payload })
	},
	archiveFarmingLevelDifficulty(payload) {
		return axios.delete(prefix + "/archive", { params: payload })
	},
	createFarmingLevelDifficulty(payload) {
		return axios.post(prefix + "/create", payload)
	},
	updateFarmingLevelDifficulty(payload) {
		return axios.post(prefix + "/update", payload)
	},
	selectFarmingLevelDifficultyCreepWaveGroup(payload) {
		return axios.post(prefix + "/select-creep-wave-group", payload)
	},
	bulkCreateFarmingLevelDifficulty(payload) {
		return axios.post(prefix + "/bulk-create", payload)
	},
}

export default FarmingLevelDifficultyApi;